import type { Price, MappedRoundTripNearestSearch } from '../types';

// TODO: add tests
/**
 * For each column we find its center position in percents
 * if its center is between 45 and 55 percents of viewport, then this column is in the center of viewport
 */
const findCenterElement = (viewportWidth: number, graphDirection: string) => {
  const columns = Array.from(
    document.getElementsByClassName(`columnElement${graphDirection}`),
  );
  return columns.find(column => {
    const colPosition = column.getBoundingClientRect();
    const leftPercent = (colPosition.left / viewportWidth) * 100;
    const rightPercent = (colPosition.right / viewportWidth) * 100;
    const middle = (leftPercent + rightPercent) / 2;
    return middle > 45 && middle < 55;
  });
};

const makeColumnActive = (
  id: number,
  searches: MappedRoundTripNearestSearch[],
) => {
  return searches.map(search => ({ ...search, isActive: search.id === id }));
};

const getColumnHeight = (maxPrice: Price, columnPrice: Price) => {
  return maxPrice && columnPrice
    ? Math.round((columnPrice / maxPrice) * 56)
    : NaN;
};

export const columnLib = {
  findCenterElement,
  makeColumnActive,
  getColumnHeight,
};
